import { render, staticRenderFns } from "./PollAddEditModal.vue?vue&type=template&id=36ba51e2&"
import script from "./PollAddEditModal.vue?vue&type=script&lang=js&"
export * from "./PollAddEditModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports